module.exports = __webpack_public_path__ + "img/logoFS.5f767764.svg";